import './SectionDetail.css';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { canUseDOM, get } from '../../utils';
import { Placeholder, Text } from '@sitecore-jss/sitecore-jss-react';
import ScrollAnimation from 'react-animate-on-scroll';
import RouterLink from '../atoms/RouterLink';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import { useEffect, useRef, useState } from 'react';
import MultipleImage from './Style_variations/MultipleImage';
import SingleImage from './Style_variations/SingleImage';
import SingleVideo from './Style_variations/SingleVideo';
import WithoutMedia from './Style_variations/WithoutMedia';
import React from 'react';
import { convertToAnalyticObject } from '../../utils/analytics';
const SectionDetail = _ref => {
  let {
    fields,
    rendering,
    params
  } = _ref;
  const left = params !== undefined && params['Left Media'] === '1' ? true : false;
  const sitecoreContext = useSitecoreContext();
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const [titleWrapperHeight, setTitleWrapperHeight] = useState({});
  const titleWrapperRef = useRef(null);
  useEffect(() => {
    if (canUseDOM) {
      if (titleWrapperRef.current) {
        setTitleWrapperHeight({
          height: `${titleWrapperRef.current.clientHeight}px`
        });
      }
    }
  }, []);
  if (!fields) {
    console.info('SectionDetail component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [SectionDetail component is empty: please provide data source]");
    }
    return null;
  }
  const title = get(fields, 'data.item.title.jss', '');
  const subtitle = get(fields, 'data.item.subtitle.jss', '');
  const description1 = get(fields, 'data.item.description1.jss', '');
  const description2 = get(fields, 'data.item.description2.jss', '');
  const cTALink = get(fields, 'data.item.cTALink.jss.value', {});
  const ctaLabel = get(fields, 'data.item.ctaLabel.jss.value', '');
  const imgSrc1 = get(fields, 'data.item.media1.jss.value.src', '');
  const alt1 = get(fields, 'data.item.media1.jss.value.alt', '');
  const imgSrc2 = get(fields, 'data.item.media2.jss.value.src', '');
  const alt2 = get(fields, 'data.item.media1.jss.value.alt', '');
  const video = get(fields, 'data.item.mediaVideo.jss.value.src', '');
  const youtubeVideo = get(fields, 'data.item.youtubeURL.jss.value', '');
  const hasCta = Boolean(get(fields, 'data.item.ctaLabel.jss.value'));
  const hasMedia1 = Boolean(get(fields, 'data.item.media1.jss.value.src'));
  const hasMedia2 = Boolean(get(fields, 'data.item.media2.jss.value.src'));
  const hasMediaVideo = Boolean(get(fields, 'data.item.mediaVideo.jss.value.src'));
  const hasYoutubeVideo = Boolean(get(fields, 'data.item.youtubeURL.jss.value'));
  const isMultipleImage = hasMedia1 && hasMedia2;
  const isWithOutMedia = !hasMedia1 && !hasMedia2 && !hasMediaVideo && !hasYoutubeVideo;
  const isSingleVideo = !hasMedia1 && hasMedia2 && (hasMediaVideo || hasYoutubeVideo);
  const isSingleImage = !isMultipleImage && !isWithOutMedia && !isSingleVideo && !hasMedia1 === hasMedia2;
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "rtl"
  }, /*#__PURE__*/React.createElement("div", {
    className: commonStyles
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: `${isWithOutMedia ? 'section-detail-container__withoutMedia' : left ? 'section-detail-containe__left' : 'section-detail-container'} row`
  }, /*#__PURE__*/React.createElement("div", {
    className: isWithOutMedia ? `col-xs-12 col-md-12 col-lg-6` : `section-detail-container--col col-xs-12 col-md-12 col-lg-5`
  }, /*#__PURE__*/React.createElement("div", {
    ref: titleWrapperRef
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    className: !left && !isWithOutMedia ? 'hideOnMobile section-detail-title' : 'section-detail-title',
    field: title
  })), subtitle && subtitle.value && subtitle.value.trim() && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h4",
    className: "section-detail-subtitle",
    field: subtitle
  }))), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: 'section-detail-description',
    field: description1
  })), hasMedia1 || hasMedia2 ? /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: 'section-detail-description',
    field: description2
  })) : null, hasCta && (hasMedia1 || hasMedia2) || rendering ? /*#__PURE__*/React.createElement("div", {
    className: "buttonsWithPlaceholderWrapper"
  }, hasCta && (hasMedia1 || hasMedia2) ? /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: "btn btn-secondary",
    href: cTALink.href,
    ariaLabel: `${title.value} - ${ctaLabel}`,
    linktype: cTALink.linktype,
    linksTarget: cTALink.target,
    onClick: () => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['StartButtonClickAnalytics'], params), ctaLabel)
  }, ctaLabel)) : null, /*#__PURE__*/React.createElement(Placeholder, {
    name: "m133-container",
    rendering: rendering
  })) : null), /*#__PURE__*/React.createElement("div", {
    className: isWithOutMedia ? `col-xs-12 col-md-12 col-lg-5` : `section-detail-container--col--media col-xs-12 col-md-12 col-lg-6`
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, !left && !isWithOutMedia ? /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    className: 'hideOnDesktop section-detail-title',
    field: title
  }) : null), isMultipleImage ? /*#__PURE__*/React.createElement(MultipleImage, {
    imgSrc1: imgSrc1,
    alt1: alt1,
    imgSrc2: imgSrc2,
    alt2: alt2,
    rtl: rtl
  }) : null, isSingleImage ? /*#__PURE__*/React.createElement(SingleImage, {
    imgSrc: hasMedia1 ? imgSrc1 : imgSrc2,
    alt: hasMedia1 ? alt1 : alt2
  }) : null, isSingleVideo ? /*#__PURE__*/React.createElement(SingleVideo, {
    imgSrc2: imgSrc2,
    alt2: alt2,
    hasYoutubeVideo: hasYoutubeVideo,
    video: hasYoutubeVideo ? youtubeVideo : video,
    title: title,
    eventsAnalytics: eventsAnalytics,
    params: params
  }) : null, isWithOutMedia ? /*#__PURE__*/React.createElement(WithoutMedia, {
    title: title,
    description2: description2,
    ctaLabel: ctaLabel,
    cTALink: cTALink,
    titleWrapperHeight: titleWrapperHeight,
    hasCta: hasCta,
    eventsAnalytics: eventsAnalytics,
    params: params
  }) : null))))))))));
};
const commonStyles = "c16hchpj";
export default SectionDetail;